<template>
  <div class="flex-align gap-2" :title="title || text" @click.stop.prevent>
    <div
      class="border rounded-lg highlight text-3 text-truncate px-2 py-1 rounded-lg"
      style="font-family: Menlo, Consolas, monospace"
    >
      {{ text }}
    </div>
    <v-btn
      v-if="showQrcode"
      variant="flat"
      size="25"
      border
      icon
      @click="openQrcode"
    >
      <AppIcon size="20" name="heroicons:qr-code-16-solid" />
    </v-btn>
    <CopyBtn :text="contentValue" size="25" variant="flat" border />
    <QRCodeDialog v-if="showQrcode" ref="qrcodeDialog" v-bind="qrcodeData" />
  </div>
</template>

<script lang="ts">
import type { QRCodeDialog } from "#components";

export default defineComponent({
  name: "TextCopy",
  props: {
    text: { type: String, required: true },
    value: { type: String },
    title: { type: String },
    qrcode: {
      type: [Object, String] as PropType<
        | string
        | {
            title: string;
            message?: string;
          }
      >,
    },
  },
  setup(props) {
    const qrcodeDialog = ref<InstanceType<typeof QRCodeDialog>>();

    const contentValue = computed(() => {
      return props.value || props.text;
    });

    const showQrcode = computed(() => {
      return contentValue.value && !!props.qrcode;
    });

    const qrcodeData = computed(() => {
      if (props.qrcode) {
        if (typeof props.qrcode === "string") {
          return {
            title: props.qrcode,
            code: contentValue.value,
          };
        } else {
          return {
            ...props.qrcode,
            code: contentValue.value,
          };
        }
      }
    });

    const openQrcode = () => {
      qrcodeDialog.value?.open();
    };

    return {
      qrcodeDialog,
      contentValue,
      qrcodeData,
      showQrcode,
      openQrcode,
    };
  },
});
</script>
